import React from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";
import VisitorLoginVM from "../viewmodal/VisitorLoginVM";

const VisitorLoginView = ({ cLogo, cBgImg }) => {
  const {
    email,
    password,
    showPassword,
    handleEmailChange,
    handlePasswordChange,
    handleLogin,
    togglePasswordVisibility,
    openForgotPassword
  } = VisitorLoginVM();

  return (
    <Box
      sx={{
        overflow: "hidden",
        width: "100%",
        minHeight: "100vh",
        backgroundImage: `url(${cBgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 3,
      }}
    >
      <Grid
        container
        justifyContent="center"
        alignItems="center"
      >
        <Card
          sx={{
            width: { xs: "90%", sm: "450px" },
            maxWidth: "450px",
            borderRadius: "16px",
            boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
            overflow: "hidden",
          }}
        >
          {cLogo && (
            <Box
              sx={{
                bgcolor: "#f7f7f7",
                py: 3,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img 
                src={cLogo} 
                alt="Company Logo" 
                style={{ 
                  height: "60px", 
                  objectFit: "contain" 
                }} 
              />
            </Box>
          )}
          
          <Box sx={{ p: { xs: 3, sm: 4 } }}>
            <Typography 
              variant="h5" 
              component="h1" 
              fontWeight="600" 
              textAlign="center" 
              mb={4}
            >
              Visitor Portal Login
            </Typography>
            
            <TextField
              id="login_email"
              type="email"
              label="Email Address"
              value={email}
              onChange={handleEmailChange}
              required
              fullWidth
              variant="outlined"
              placeholder="Enter your email"
              InputProps={{
                sx: { borderRadius: "8px" }
              }}
              sx={{ mb: 2.5 }}
            />
            
            <TextField
              id="login_password"
              type={showPassword ? "text" : "password"}
              label="Password"
              value={password}
              onChange={handlePasswordChange}
              required
              fullWidth
              variant="outlined"
              placeholder="Enter your password"
              InputProps={{
                sx: { borderRadius: "8px" },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={togglePasswordVisibility}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              sx={{ mb: 1 }}
            />
            
            <Box sx={{ textAlign: "right", mb: 3 }}>
              <Link
                component="button"
                variant="body2"
                onClick={openForgotPassword}
                sx={{ textDecoration: "none" }}
              >
                Forgot Password?
              </Link>
            </Box>

            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{
                borderRadius: "8px",
                py: 1.5,
                textTransform: "none",
                fontSize: "16px",
                mt: 2,
                boxShadow: 2
              }}
              onClick={handleLogin}
            >
              Log In
            </Button>
          </Box>
        </Card>
      </Grid>
    </Box>
  );
};

export default VisitorLoginView;